// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { LocalStorageService } from '../../core/services';
import { aavnIshcmcEnv, bisHanoiDevEnv, bisHanoiEnv, bisHanoiStagingEnv, demoHelenEnv, ishcmcEnv, isspEnv, primaryIshcmcEnv, secondaryIshcmcEnv } from '../../../config/config';

@Component({
    selector: 'user-logout',
    template: '',
    styles: [],
})

export class LogoutComponent {
    private errorMessage: string;
    protected hostName: string;
    // For logout navigate
    protected devEnv: any = ['camp.eca.nascorp.vn', 'asa.eca.nascorp.vn', 'holiday.eca.nascorp.vn', 'bus.eca.nascorp.vn', 'reen.eca.nascorp.vn'];
    protected testEnv: any = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['staging.outdooreducation.aisvietnam.com', 'staging.asa.aisvietnam.com', 'staging.holidayschool.aisvietnam.com', 'staging.bus.aisvietnam.com', 'staging.reen.aisvietnam.com'];
    protected procEnv: any = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com']
    protected prodEnv: any = ['outdooreducation.ishcmc.nascorp.vn', 'holidayschool.ishcmc.nascorp.vn', 'bus.ishcmc.nascorp.vn']
    protected prodEnvEishcmc: any = ['bus.eishcmc.exe.school'];
    protected demoEnv = ['camp.demo.nascorp.vn', 'asa.demo.nascorp.vn', 'holiday.demo.nascorp.vn', 'bus.demo.nascorp.vn', 'reen.demo.nascorp.vn'];
    protected prodEnvBishanoi: any = ['bus.bishanoi.exe.school'];
    protected prodEnvBishcm: any = ['bus.bishcm.exe.school'];
  	protected prodEnvIssp: any = ['bus.issp.exe.school'];
  	protected prodEnvBishanoistaging: any = ['bus.bishanoistaging.exe.school'];

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private localStorageService: LocalStorageService,
        private userService: UserService
    ) { }

    ngOnInit() {
        this.hostName = window.location.hostname;
        // Delete session from system
        this.deleteSession();
    }

    /**
     * Delete user session data.
     */
    private deleteSession() {
        this.sessionService.deleteSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.userService.clearUserSessionData();

                    // Fire user session data changed event
                    this.userService.userDataChanged(null);

                    // Redirect to desired URL                    
                    if (this.devEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eca.nascorp.vn';
                    }
                    else if (this.testEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eca.test.nascorp.vn';
                    }
                    else if(bisHanoiEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiEnv.services}`;
                    }
                    else if(bisHanoiDevEnv.indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiDevEnv.services}`;
                    }
                    else if(Object.values(bisHanoiStagingEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiStagingEnv.services}`;
                    }
                    else if(Object.values(ishcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${ishcmcEnv.services}`;
                    }
                    else if(Object.values(aavnIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${aavnIshcmcEnv.services}`;
                    }
                    else if(Object.values(primaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${primaryIshcmcEnv.services}`;
                    }
                    else if(Object.values(secondaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${secondaryIshcmcEnv.services}`;
                    }
                    else if(Object.values(isspEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${isspEnv.services}`;
                    }
                    else if(Object.values(demoHelenEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${demoHelenEnv.services}`;
                    }
                    else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://staging.services.aisvietnam.com';
                    }
                    else if (this.procEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'https://services.aisvietnam.com';
                    }
                    else if (this.prodEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.ishcmc.nascorp.vn/login';
                    }
                    else if (this.prodEnvEishcmc.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.eishcmc.exe.school/login';
                    }
                    else if (this.demoEnv.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://auth.demo.nascorp.vn';
                    }
                    else if (this.prodEnvBishanoi.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.bishanoi.exe.school/login';
                    }
                    else if (this.prodEnvBishcm.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.bishcm.exe.school/login';
                    }
                    else if (this.prodEnvIssp.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.issp.exe.school/login';
                    }
                    else if (this.prodEnvBishanoistaging.indexOf(this.hostName) !== -1) {
                        return window.location.href = 'http://services.bishanoistaging.exe.school/login';
                    }                  
                    else {
                        return window.location.href = 'http://services.local.eca.nascorp.vn';
                    }
                },
                error => this.errorMessage = <any>error
            );
    }

    // Redirect to desired url
    private redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/user/logout/LogoutComponent.ts